/**
 * Utility for WhatsApp integration
 */

// Al-Zaeem Real Estate business WhatsApp number
export const WHATSAPP_NUMBER = '971521138999';

/**
 * Generates a WhatsApp link
 * @param {string} message - The message to pre-fill
 * @param {string} number - Optional override for phone number
 * @returns {string} - The intent URL
 */
export const getWhatsAppLink = (message = '', number = WHATSAPP_NUMBER) => {
    const encodedMessage = encodeURIComponent(message);
    return `https://wa.me/${number}?text=${encodedMessage}`;
};

/**
 * Common message templates
 */
export const WhatsAppMessages = {
    generalInquiry: "Hello, I would like to know more about Al-Zaeem properties.",
    projectInquiry: (projectName, location) => `Hello, I am interested in the project "${projectName}" in ${location}. Please provide more details.`,
    customInquiry: (details) => `Hello, I have a specific request: ${details}`
};
